import { createAsyncThunk } from '@reduxjs/toolkit';
import { RequestShiftPayload, ShiftWizardApi } from 'api/ShiftWizardApi';

import { ErrorResponse } from './ErrorResponse';

export interface RequestShiftParams extends RequestShiftPayload {
  appId: string;
}

export const createRequestShiftThunk = (api: ShiftWizardApi) =>
  createAsyncThunk('shiftWizard/requestShift', async ({ appId, shiftRequirementId }: RequestShiftParams, thunkApi) => {
    try {
      await api.requestShift(appId, { shiftRequirementId });
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
